import { render, staticRenderFns } from "./ReportMessage.vue?vue&type=template&id=1437b184&"
import script from "./ReportMessage.vue?vue&type=script&lang=js&"
export * from "./ReportMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReportMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports